// extracted by mini-css-extract-plugin
module.exports = {"description":"serviceCardStyle_description__150VT"};